import { RTKQueryTag } from 'src/common/constants';
import type { LoginData, LoginResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginData>({
      query: ({ reCaptcha, ...body }) => {
        const headers: Record<string, string> = {};
        if (reCaptcha) {
          headers['x-recaptcha-response'] = reCaptcha;
        }
        return {
          url: '/auth/login',
          method: 'POST',
          body,
          headers,
        };
      },
      invalidatesTags: [RTKQueryTag.Campaigns],
    }),
  }),
});

export const { useLoginMutation } = extendedApiSlice;
